import { Search } from './search.js';

class HeaderSearch extends Search {
    constructor(selector) {
        super(selector);
        let _this = this;
        this.searchWrapper = $(this.input).closest('.js-search-wrapper');
        this.navbar = $(this.input).closest('.shop-header__navbar');

        $(window).on('resize', function () {
            if ($(_this.searchWrapper).hasClass('active')) {
                console.log('a');
                _this.checkNavClass();
            }
        });
    }

    showSearch() {
        this.checkNavClass();
        $(this.searchWrapper).addClass('active');
    }

    hideSearch() {
        this.resetNavClass();
        $(this.searchWrapper).removeClass('active');
    }

    checkNavClass() {
        if (
            $(window).innerWidth() <
            $('.shop-header__menu').outerWidth() + 420
        ) {
            $(this.navbar).addClass('hidden-nav');
        } else {
            $(this.navbar).removeClass('hidden-nav');
        }
    }

    resetNavClass() {
        $(this.navbar).removeClass('hidden-nav');
    }
}

export const headerSearch = new HeaderSearch('.js-header-search');
